import { render, staticRenderFns } from "./CultureAboutJinqiaoContentUseAudit.vue?vue&type=template&id=1ba6607c&scoped=true&"
import script from "./CultureAboutJinqiaoContentUseAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAboutJinqiaoContentUseAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6607c",
  null
  
)

export default component.exports